import {
  Button, Card, CardActions, CardContent, CardHeader, CircularProgress,
  Divider, InputLabel, List, ListItem,
  ListItemSecondaryAction, ListItemText,
  TextField, Typography
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useMemo } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { getCategories } from 'src/utils/storage/commentCategories';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { Autocomplete } from '@material-ui/lab';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsComboYorum: {
    margin: theme.spacing(0),
    display: 'flex',
  },
  content: {
    minHeight: 160,
  },
  submitButtonComment: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

function Yorum({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [YorumDetay, setYorumDetay] = React.useState([]);

  const tasksList = tasks?.tasks;
  const YorumData = useMemo(() => {
    let data = readonly ? (Array.isArray(tasksList) ? tasksList.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

    if (!readonly && (!data || data.length === 0)) {
      const current = tasksList?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
      if (current) {
        saveBaslandiJob(current);
        data = loadBaslandiJob();
      }
    }

    return data;
  }, [readonly, tasksList, FisNo]);


  const [Kullanici, setKullanici] = useState([]);
  const [KullaniciId, setKullaniciId] = useState(0);
  const [Yorum, setYorum] = useState("");

  const [KararData, setKararData] = React.useState([]);
  const [valueKarar, setvalueKarar] = React.useState(0);

  useEffect(() => {
    let isMounted = true;
    const basvuruNo = YorumData[0]?.BasvuruNo;
    const serviceShopId = SessionUser.ServiceShopId;
    const technicianId = SessionUser.TechnicianId;

    if (!basvuruNo) {
      return;
    }

    axios.get(`/GetArtemisYorumKullanici/${basvuruNo}/${serviceShopId}/${technicianId}`)
      .then(response => {
        if (!isMounted) return;
        if (response.data.length > 0) {
          setKullanici(response.data);
        }
      })
      .catch(error => {
        logger.error("Hata detayı:", error.message);
      });

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [YorumData[0]?.BasvuruNo, SessionUser.ServiceShopId, SessionUser.TechnicianId]);
  const handleChangeKullanici = (e) => {
    setKullaniciId(e.target.value);
  }
  const handleChangeYorum = (e) => {
    setYorum(e.target.value);
  }
  const handleYorumYap = () => {
    if (Yorum.length === 0) {
      setUyariTip("error");
      setUyariAciklama("Lütfen yorum yazınız!..");
      setUyari(true);
      return;
    }

    if (valueKarar === 0) {
      setUyariTip("error");
      setUyariAciklama("Lütfen kategori seçiniz!..");
      setUyari(true);
      return;
    }
    const data1 = {
      BIRIM_KODU: parseInt(YorumData[0]?.BIRIM_KODU) || 0,
      BASVURU_NO: parseInt(YorumData[0]?.BasvuruNo) || 0,
      FIS_NO: parseInt(YorumData[0]?.FisNo) || 1,
      SICIL: parseInt(KullaniciId) || 0,
      MESAJ: Yorum || '',
      GONDEREN_SICIL: parseInt(SessionUser.OrganizationUserId) || 1,
      SIRANO: 1,
      KONTROL: 3,
      KARAR: valueKarar || 0
    };

    const config1 = {
      headers: { 'Content-Type': 'application/json' }
    }
    setLoadingControl(true);
    axios.post('/SetArtemisYorum', data1, config1)
      .then(response => {
        setLoadingControl(false);
        let ResponseData1 = response.data;
        if (parseInt(ResponseData1.ErrorCode) !== 0) {
          setUyariTip("error");
          setUyariAciklama(ResponseData1.ErrorDescription);
        } else {
          setUyariTip("success");
          setUyariAciklama(ResponseData1.ErrorDescription);
          GetYorum();
        }
        setUyari(true);
      })

  }

  const setYorumSilEvet = (Id) => {
    const data = [{
      AppNr: YorumData[0]?.BASVURU_NO,
      ServiceShopId: YorumData[0]?.BIRIM_KODU,
      CommentRequested: 0,
      UserId: YorumData[0]?.TEKNISYEN_KODU,
      Comment: "",
      Operation: 0,
      CommentId: Id,
      Decision: 0,
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    setLoadingControl(true);
    axios.post('/SetArtemisComment', data, config)
      .then(response => {
        setLoadingControl(false);
        let ResponseData = response.data;
        if (parseInt(ResponseData.ErrorCode) !== 0) {
          setUyariTip("error");
          setUyariAciklama(ResponseData.ErrorDescription);
        } else {
          setUyariTip("success");
          setUyariAciklama(ResponseData.ErrorDescription);
          GetYorum();
        }
        setUyari(true);
      })

  }

  const setYorumSil = (Id) => {
    confirmAlert({
      message: 'Yorum Silinecektir. Onaylıyor musunuz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => setYorumSilEvet(Id)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }



  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const GetYorum = () => {
    setLoadingControl(true);
    axios.get('/GetArtemisYorumDetay/' + FisNo)
      .then(response => {
        const Deger = response.data;
        if (Deger.length === 0) {
          setYorumDetay([]);
        } else {
          setYorumDetay(Deger);
        }
        setLoadingControl(false);
      })
  }

  useEffect(() => {
    GetYorum();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      let cat = await getCategories();
      setKararData(cat);
    }
    fetchCategories();
  }, []);

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader title={"Fiş Yorum"} />
      <Divider />
      {
        uyari ?
          <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
          : <div></div>
      }
      <CardContent>
        {LoadingControl ?
          <CircularProgress
            status={'loading'}
            style={{ marginLeft: '50%' }}
          />
          : ""
        }
        <Typography variant="h6" component="h2" gutterBottom>
          <Autocomplete
            id="kullanici-autocomplete"
            options={Kullanici.sort((a, b) => a.ADSOYAD.localeCompare(b.ADSOYAD))}
            getOptionLabel={(option) => option.ADSOYAD || ""}
            // value nesnenin kendisini bekler, ID'yi bulup eşleştiriyoruz
            value={Kullanici.find((p) => p.ID === KullaniciId) || null}
            onChange={(event, newValue) => {
              // handleChangeKullanici fonksiyonunuza uygun şekilde simüle ediyoruz
              handleChangeKullanici({
                target: { value: newValue ? newValue.ID : "0", name: "kullanici_select" }
              });
            }}
            disabled={readonly}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Kullanıcı"
                variant="outlined"
                placeholder="Belirli bir kişi varsa seçiniz!..."
                className={classes.fieldsComboYorum} // Mevcut stilinizi buraya taşıyın
                fullWidth
              />
            )}
          />
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <FormControl variant="outlined" className={classes.fieldsComboYorum}>
            <InputLabel disabled={readonly}>Kategori</InputLabel>
            <Select
              native
              value={valueKarar}
              onChange={(e) => setvalueKarar(e.target.value)}
              label="Karar"
              disabled={readonly}
              fullWidth
            >
              <option value="0" defaultValue>Kategori Seçiniz!...</option>
              {KararData.filter(k => k.TIP === (SessionUser.ServiceShopId === 99 ? "BOLGE" : "SERVIS")).map(p => {
                return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
              })}
            </Select>
          </FormControl>
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            label={"Yorum"}
            name="Yorum"
            multiline
            minRows={4}
            fullWidth
            value={Yorum}
            onChange={handleChangeYorum}
            variant="outlined"
            disabled={readonly}
          />
        </Typography>

      </CardContent>
      <Divider />
      <CardActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleYorumYap}
          disabled={readonly}
          fullWidth
          endIcon={<SendIcon>Gonder</SendIcon>}
        >
          {"Gönder"}
        </Button>
      </CardActions>
      <Divider className={classes.dividerYorum} />
      <CardContent className={classes.content}>
        <List className={classes.root}>
          {YorumDetay.map(log => (
            <div key={log.ID}>
              <ListItem alignItems="flex-start">
                <ListItemText
                  primary={""}
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body1"
                        className={classes.inline}
                        color="textPrimary"
                      >
                        <b>Yorum İleten:</b> {log.YORUM_ILETEN}
                        <br></br>
                        <b>Tarih:</b> {log.YORUM_TARIH}
                        <br></br>
                        <b>Mesaj:</b> {log.MESAJ}
                        <br></br>
                        <b>Yanıtlayan:</b> {log.YANITLAYAN}
                        <br></br>
                        <b>Yanıt Tarih:</b> {log.YANIT_TARIH}
                        <br></br>
                        <b>Yanıt:</b> {log.YANIT}
                      </Typography>
                    </React.Fragment>
                  }
                />
                <ListItemSecondaryAction>
                  <RemoveCircleIcon onClick={() => setYorumSil(log.ID)} style={{ color: "red" }} />
                </ListItemSecondaryAction>
              </ListItem>
              <Divider className={classes.dividerYorum} />
            </div>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}

Yorum.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({
    tasks: state.tasks1
  })
)(Yorum);
